import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentChatConversation, MutationIntentChatConversationDeleteArgs } from "types/generated";

type ChatConversationDeleteData = {
  intentChatConversationDelete: Pick<IntentChatConversation, "id"> | null;
};

export const CHAT_CONVERSATION_DELETE: TypedDocumentNode<
  ChatConversationDeleteData,
  MutationIntentChatConversationDeleteArgs
> = gql`
  mutation ChatConversationDelete($id: ID!) {
    intentChatConversationDelete(id: $id) {
      id
    }
  }
`;
